import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { selectSignedIn } from '@/shared/api/sessionSlice';
import { linkButton } from '@/shared/ui/Button';
import { Alert } from '@/shared/ui/primitives';
import { urlOf } from '@/shared/lib/site';

import { signInUrl } from './destination';

/**
 * Said to whoever takes public lessons without an account (a visitor, a guest): it can
 * be done right away, and signing in or registering in this browser keeps it. Nothing
 * for an account.
 */
export function GuestNotice({ className }: { className?: string }) {
  const { t } = useTranslation();
  const signedIn = useSelector(selectSignedIn);
  const location = useLocation();
  if (signedIn) return null;
  return (
    <Alert className={className}>
      <p>{t('guest.notice')}</p>
      <p className="mt-3 flex flex-wrap gap-2">
        <a href={urlOf('home', '/register')} className={linkButton('primary')}>
          {t('guest.register')}
        </a>
        <a href={signInUrl(location)} className={linkButton('secondary')}>
          {t('nav.signIn')}
        </a>
      </p>
    </Alert>
  );
}
